import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button';
import LabeledPasswordInput from '../../../generic/Forms/LabeledPasswordInput';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import type { GoProxy } from '../../../../../typings/common';

import styles from '../Languages.module.less';

type ProxyProps = Pick<GoProxy, 'url' | 'username' | 'password' | 'hasPassword'> & {
  onUpdateProxy: <K extends keyof GoProxy>(
    member: K,
    value: GoProxy[K],
  ) => void;
  onRemove: () => void;
};

/**
 * Go settings Proxy row.
 */
const Proxy: VoidFunctionComponent<ProxyProps> = ({
  url,
  username,
  password,
  hasPassword,
  onUpdateProxy,
  onRemove,
}) => (
  <div className="margin-bottom-sm">
    <div className={styles.fieldsRow}>
      <div className={styles.fieldWrapper}>
        <LabeledTextInput
          labelVariant="legacy"
          label="URL"
          value={url || ''}
          size="small"
          onChange={value => onUpdateProxy('url', value)}
          placeholder="https://proxy.example.com"
        />
      </div>
      <div className={styles.fieldWrapper}>
        <LabeledTextInput
          labelVariant="legacy"
          label="Username"
          size="small"
          value={username || ''}
          onChange={value => onUpdateProxy('username', value)}
          placeholder="username"
        />
      </div>
      <div className={styles.fieldWrapper}>
        <LabeledPasswordInput
          label="Password"
          size="small"
          value={hasPassword ? '••••••••' : password?.value || ''}
          onChange={value => onUpdateProxy('password', { __type: 's', value })}
        />
      </div>
      <Button
        type="error"
        size="small"
        onClick={onRemove}
      >
        Remove
      </Button>
    </div>
  </div>
);

export default Proxy;
